import { isProduction } from 'helpers/envInfo'


/**
 * @param msg
 * @param type {String} - log output type (info, warn, error)
 */
export default function (msg, type = 'log') {
    if (!isProduction) {
        console[type](msg)
    }
}
